<template>
<div>
  <h4 class="title is-6">
    {{ checkpoint.value }}
  </h4>
  <div class="columns">
    <div class="column">
      <h4 class="is-size-4">Standards ({{ checkpoint.sections.length }})</h4>
    </div>
    <div class="column is-narrow">
      <action-button
        @click="openStandardsSelector"
        left-icon="plus">
        Standard
      </action-button>
    </div>
  </div>
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Standard</th>
        <th>Section</th>
        <th class="is-narrow">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="section in checkpoint.sections" :key="section.id">
        <td>
          {{ section.standard.name }}
        </td>
        <td>
          {{ section.title }}
        </td>
        <td>
          <action-button class="is-small is-danger is-rounded" @click="removeFromCheckpoint(section)">
            <icon icon="trash"/>
          </action-button>
        </td>
      </tr>
    </tbody>
  </table>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { addStandardToCheckpoint } from '@/modals'

export default {

  data: () => ({
    saving: false
  }),

  methods: {
    openStandardsSelector() {
      addStandardToCheckpoint(this.checkpoint).then(reload => {
        if(reload) {
          this.$store.dispatch('checkpoint/loadCheckpoint', this.$route.params.checkpoint)
        }
      })
    },
    async removeFromCheckpoint(section) {
      if(await this.$confirm({
        title: 'Remove Standard',
        message: 'Are you sure you want to remove this standard? All findings previously captures on customer sites will be removed as well.'
      })) {
        this.$store.dispatch('checkpoint/removeStandard', section).then(() => {
          this.$toast.success('Standard removed')
        })
      }
    }
  },

  computed: {
    ...mapGetters('checkpoint', [
      'checkpoint'
    ]),
  }

}
</script>